<template>
    <div :class="{
        'main-center-container': true,
        'main-center-container--width-800': width800,
        'main-center-container--width-1100': width1100,
        }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'MainCenterContainer',
    props: {
        width800: { type: Boolean, default: true},
        width1100: { type: Boolean, default: false}
    }
}
</script>

<style lang="scss" scoped>
    .main-center-container {
        display: flex;
        height: 100% !important;
        box-sizing: border-box;
        flex-direction: column;
        padding: 0px;
        border: 0px solid #fff;
        width: 100%;
        &--width-800 {
            max-width: 800px;
        }
        &--width-1100 {
            max-width: 1100px;
        }
    }
</style>